import React, { useState, useEffect } from 'react';
import { Grid, Typography, CircularProgress, Box, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { fetchExternalReportDetails, fetchExternalReportByDataProduct, fetchAllExternalReports } from '../../lib/services/externalReportService';
import ExternalReportPage from './ExternalReportPage';

const ExternalReportsPage = ({ drawerWidth, idToken }) => {
    const { reportId } = useParams();
    const [searchParams] = useSearchParams();
    const dataProduct = searchParams.get('dataProduct');
    const defaultReportId = '255a11c9-29f2-4358-b56d-44d4bde76250';
    
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [allReports, setAllReports] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!idToken) return;

        // Fetch all reports for the sidebar
        fetchAllExternalReports(idToken, setAllReports, () => {}, () => {});

        // Priority: dataProduct query param > reportId URL param > default
        if (dataProduct) {
            fetchExternalReportByDataProduct(idToken, dataProduct, setReport, setLoading, setError);
        } else {
            const activeReportId = reportId || defaultReportId;
            fetchExternalReportDetails(idToken, activeReportId, setReport, setLoading, setError);
        }
    }, [idToken, reportId, dataProduct]);

    if (loading) {
        return (
            <Box 
                display="flex" 
                justifyContent="center" 
                alignItems="center" 
                style={{ 
                    marginTop: '30px', 
                    marginLeft: drawerWidth,
                    height: 'calc(100vh - 100px)'
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Grid 
            container 
            spacing={2} 
            style={{ 
                marginTop: '30px', 
                marginLeft: drawerWidth,
                height: '100%',
                width: `calc(95% - ${drawerWidth}px)`
            }}
        >
            <Grid item xs={2.5} style={{ height: '91.5vh', borderRight: '1px solid #eee', overflow: 'auto' }}>
                <Typography variant="h6" sx={{ padding: '16px', borderBottom: '1px solid #eee' }}>
                    Available Reports
                </Typography>
                <List>
                    {allReports.map((r) => (
                        <ListItem key={r.id} disablePadding>
                            <ListItemButton
                                selected={reportId === r.id}
                                onClick={() => navigate(`/external-reports/${r.id}`)}
                            >
                                <ListItemText 
                                    primary={r.title}
                                    secondary={r.type}
                                    primaryTypographyProps={{
                                        style: { fontSize: '0.9rem' }
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Grid>
            <Grid item xs={9.5}>
                <ExternalReportPage report={report} loading={false} error={error} />
            </Grid>
        </Grid>
    );
};

export default ExternalReportsPage;
